<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card width="500">
        <v-card-title class="text-h6 white--text third">
          <span class="d-flex justify-left flex-grow-1">Sélectionnez Un Cavalier</span>
          <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-autocomplete
            v-model="selectedCustomer"
            :search-input.sync="searchValue"
            color="third"
            flat
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Recherche"
            :items="autoCompleteCustomers"
            item-text="fullname"
            item-value="uuid"
            :loading="loading"
            :disabled="loading"
            :menu-props="{ 'z-index': '1500 !important'}"
            return-object
            @keyup.enter="searchOnAlgolia"
            @input="selectParticipant"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { inject, computed, ref } from '@vue/composition-api';
import { searchCustomerOnAlgolia } from '@/helpers/search';
import { getContractWithStock } from '@/helpers/request';
import { sendNotification, isObjectEmpty } from '@/helpers/utils';

import store from '@/store';

export default {
  setup () {
    const dialog = inject('addParticipantDialog');
    const session = inject('selectedSession');

    const showParticipantModal = inject('showParticipantModal');
    const selectParticipantModalData = inject('selectParticipantModalData');

    const searchValue = ref(null);
    const selectedCustomer = inject('selectedParticipant');
    const loading = ref(false);

    const algoliaCustomers = computed(() => store.state.algoliaCustomers);

    const autoCompleteCustomers = computed(() => {
      const returnValue = [];

      // session.value.participants.map(p => (returnValue.push({ ...p, showMoreButton: false, fullname: `${p.firstname} ${p.lastname}` })));

      algoliaCustomers.value.map(customer => {
        const isParticipantAlreadyonSession = session.value.participants.some(p => p.uuid === customer.uuid);

        if (!isParticipantAlreadyonSession) {
          returnValue.push(customer);
        }
      });

      return returnValue;
    });

    const closeModal = () => {
      searchValue.value = null;
      selectedCustomer.value = null;
      dialog.value = false;
    };

    const searchOnAlgolia = () => {
      searchCustomerOnAlgolia(searchValue.value);
    };

    const selectParticipant = async () => {
      loading.value = true;
      if (selectedCustomer.value && !isObjectEmpty(selectedCustomer.value)) {
        // showParticipantModal.value = true
        const text = 'Obtenir des contrats clients ...';
        sendNotification('info', text);
        const contractsWhithStock = await getContractWithStock(selectedCustomer.value.uuid);
        selectParticipantModalData.value = { ...selectParticipantModalData.value, contracts: contractsWhithStock.data, user: selectedCustomer.value, session: session.value };
        showParticipantModal.value = true;
        searchValue.value = null;
      }
      loading.value = false;
    };

    return { loading, dialog, closeModal, autoCompleteCustomers, searchOnAlgolia, searchValue, selectedCustomer, selectParticipant };
  }
};
</script>
